export default __webpack_public_path__ + "static/media/i054jp.74f2679b.webp";